import i18next from "i18next";
import { initReactI18next } from "react-i18next";


i18next
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        resources: {
            en: {
                translation: {
                    studentID: "ID",
                    name: "Name",
                    userName: "Username",
                    contact: "Contact",
                    password: "Password",
                    email: "Email",
                    address: "Address",
                    birthDate: "Date of Birth",
                    marks: "Marks",
                    totalMarks: "Total Marks",
                    obtainedMarks: "Obtained Marks",
                    percentage: "Percentage",
                }
            },
            tr: {
                translation: {
                    studentID: "İD",
                    name: "İsim",
                    userName: "Kullanıcı adı",
                    contact: "Temas etmek",
                    password: "Şifre",
                    email: "E-posta",
                    address: "Adres",
                    birthDate: "Doğum tarihi",
                    marks: 'işaretler',
                    totalMarks: "Toplam puan",
                    obtainedMarks: "Alınan Notlar",
                    percentage: "Yüzde",
                }
            }
        }

    })